import {
  FlatActionList,
  Text,
  ProductThumbnail,
  Stack,
} from "@towersystems/roam-common-native";
import { StockOrderItem } from "@towersystems/roam-common/lib/generated-types";
import React from "react";
import { Spacings, View } from "react-native-ui-lib";
import { useTranslation } from "../../../../utilities/i18n";

export interface OrderItemFlatActionListProps {
  items: StockOrderItem[];
  onPressAll?: (item: StockOrderItem) => void;
}

export const OrderItemFlatActionList = ({
  items,
  onPressAll,
}: OrderItemFlatActionListProps) => {
  const { t } = useTranslation("stockorder");

  const sortedItems = React.useMemo(
    () =>
      items.slice().sort((a, b) => {
        const createdAtA = new Date(a.createdAt);
        const createdAtB = new Date(b.createdAt);
        //@ts-ignore
        return createdAtB - createdAtA;
      }),
    [items]
  );

  return sortedItems.length >= 1 ? (
    <FlatActionList
      style={{ overflow: "visible" }}
      items={sortedItems.map((item) => ({
        key: item.id,
        titleContent() {
          return (
            <View flex row>
              <View
                style={{
                  alignItems: "center",
                  flexBasis: "100%",
                  flexShrink: 1,
                }}
                row
              >
                <ProductThumbnail
                  imageUrl={item.product?.image?.path}
                  isInternalProduct={false}
                  size="large"
                />
                <View marginL-20 style={{ flexShrink: 1 }}>
                  <Text variant="heading2">
                    {item.product?.name ?? item.name ?? t("common:not_found")}
                  </Text>
                  <Text variant="heading5">
                    {item.product?.stockNumber ?? item?.barcode ?? ""}
                  </Text>
                </View>
              </View>
            </View>
          );
        },
        title: "",
        onPress: onPressAll ? () => onPressAll?.(item) : undefined,
        componentRight: (icon) => (
          <Stack style={{ marginLeft: Spacings.s4 * 2 }} spacing={1}>
            <View style={{ alignItems: "flex-end" }}>
              <Text variant="heading2">{item.quantity}</Text>
            </View>
            {onPressAll && icon}
          </Stack>
        ),
      }))}
    ></FlatActionList>
  ) : null;
};
